import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { UnsubscribeUseCase } from './UnsubscribeUseCase';
import { BoltUserSubscriptionTwoStepsUseCase } from './BoltUserSubscriptionTwoStepsUseCase';
import { BoltUserSubscriptionUseCase } from './BoltUserSubscriptionUseCase';
import { BoltUserVerificationTwoStepsUseCase } from './BoltUserVerificationTwoStepsUseCase';
import { GetSubscriptionStatusUseCase } from './GetSubscriptionStatusUseCase';
import { QitafGenerateOtpUseCase } from './QitafGenerateOtpUseCase';
import { QitafVerifyOtpUseCase } from './QitafVerifyOtpUseCase';
import { TpayRedirectSubscribeExistingUseCase } from './TpayRedirectSubscribeExistingUseCase';
import { UserRegisterGeneratePinUseCase } from './UserRegisterGeneratePinUseCase';
import { UserRegisterVerifyPinUseCase } from './UserRegisterVerifyPinUseCase';
import { UserRegisterUseCase } from './UserRegisterUseCase';
import { TpayRedirectSubscribeNewUseCase } from './TpayRedirectSubscribeNewUseCase';
import { QrCodeLinkUseCase } from './QrCodeLinkUseCase';
import { CampaignGenerateUseCase } from './CampaignGenerateUseCase';
import { CampaignVerifyUseCase } from './CampaignVerifyUseCase';
import { CheckUserUseCase } from './CheckUserUseCase';
import { ValidateActivationLinkUseCase } from './ValidateActivationLinkUseCase';
import { DisneyGenerateOtpUseCase } from './DisneyGenerateOtpUseCase';
import { DisneyValidateOtpUseCase } from './DisneyValidateOtpUseCase';
import { DisneyRequestActivationLinkUseCase } from './DisneyRequestActivationLinkUseCase';
import { PartnerActivationRedirectionUseCase } from './PartnerActivationRedirectionUseCase';

export const initializeSubscriptionUseCases = (container: Container) => {
    container.register(DI.USECASES.IBoltUserSubscriptionTwoStepsUseCase, {
        useClass: BoltUserSubscriptionTwoStepsUseCase,
    });
    container.register(DI.USECASES.IBoltUserSubscriptionUseCase, {
        useClass: BoltUserSubscriptionUseCase,
    });
    container.register(DI.USECASES.IBoltUserVerificationTwoStepsUseCase, {
        useClass: BoltUserVerificationTwoStepsUseCase,
    });
    container.register(DI.USECASES.IGetSubscriptionStatusUseCase, {
        useClass: GetSubscriptionStatusUseCase,
    });
    container.register(DI.USECASES.ISubscriptionQitafGenerateOtpUseCase, {
        useClass: QitafGenerateOtpUseCase,
    });
    container.register(DI.USECASES.ISubscriptionQitafVerifyOtpUseCase, {
        useClass: QitafVerifyOtpUseCase,
    });
    container.register(DI.USECASES.ITpayRedirectSubscribeExistingUseCase, {
        useClass: TpayRedirectSubscribeExistingUseCase,
    });
    container.register(DI.USECASES.ITpayRedirectSubscribeNewUseCase, {
        useClass: TpayRedirectSubscribeNewUseCase,
    });
    container.register(DI.USECASES.IUnsubscribeUseCase, {
        useClass: UnsubscribeUseCase,
    });
    container.register(DI.USECASES.IUserRegisterGeneratePinUseCase, {
        useClass: UserRegisterGeneratePinUseCase,
    });
    container.register(DI.USECASES.IUserRegisterUseCase, {
        useClass: UserRegisterUseCase,
    });
    container.register(DI.USECASES.IUserRegisterVerifyPinUseCase, {
        useClass: UserRegisterVerifyPinUseCase,
    });
    container.register(DI.USECASES.IQrCodeLinkUseCase, {
        useClass: QrCodeLinkUseCase,
    });
    container.register(DI.USECASES.ICampaignGenerateUseCase, {
        useClass: CampaignGenerateUseCase,
    });
    container.register(DI.USECASES.ICampaignVerifyUseCase, {
        useClass: CampaignVerifyUseCase,
    });
    container.register(DI.USECASES.ICheckUserUseCase, {
        useClass: CheckUserUseCase,
    });
    container.register(DI.USECASES.IValidateActivationLinkUseCase, {
        useClass: ValidateActivationLinkUseCase,
    });
    container.register(DI.USECASES.IDisneyGenerateOtpUseCase, {
        useClass: DisneyGenerateOtpUseCase,
    });
    container.register(DI.USECASES.IDisneyValidateOtpUseCase, {
        useClass: DisneyValidateOtpUseCase,
    });
    container.register(DI.USECASES.IDisneyRequestActivationLinkUseCase, {
        useClass: DisneyRequestActivationLinkUseCase,
    });
    container.register(DI.USECASES.IPartnerActivationRedirectionUseCase, {
        useClass: PartnerActivationRedirectionUseCase,
    });
};
